'use client';
import { cn } from '@bells/core/lib/utils';

type Props = {
  src: string;
  className?: string;
  component?: 'div' | 'span';
};

export const InlineSVG = ({
  src,
  className = '',
  component = 'div',
}: Props) => {
  const svg = src.replace(/<\?xml.*\?>/, '');

  if (!svg.startsWith('<svg')) {
    return <></>;
  }
  const Component = component;

  return (
    <Component
      className={cn('h-full w-full', className)}
      dangerouslySetInnerHTML={{
        __html: svg.replace(
          '<svg',
          `<svg class="w-full h-full object-contain"`
        ),
      }}
    ></Component>
  );
};

InlineSVG.displayName = 'InlineSVG';
